"use client";

import { cn } from "@/lib/utils";
import { Marquee } from "@/components/ui/marquee";

const waTrainingModules = [
  {
    name: "WA Foundation",
    body: "Basics on warehouse advantage. The RF device, Main RF processes, Main web pages",
  },
  {
    name: "WA Advanced",
    body: "Infios Tech Stack: SQL, Architect, Web Wise Page Editor",
  },
  {
    name: "WA Operations",
    body: " Warehouse support and maintenance. Debugging and fixing issues",
  },
];

export function WATrainingModules() {
  return (
    <Marquee pauseOnHover className="absolute top-10 [mask-image:linear-gradient(to_top,transparent_5%,#000_100%)] [--duration:20s]">
      {waTrainingModules.map((module, idx) => (
        <figure
          key={idx}
          className={cn(
            "relative w-32 cursor-pointer rounded-xl border p-4",
            "border-gray-950/[.1] bg-gray-950/[.01] hover:bg-gray-950/[.05]",
            "dark:border-gray-50/[.1] dark:bg-gray-50/[.10] dark:hover:bg-gray-50/[.15]",
            "transform-gpu transition-all duration-300 ease-out",
          )}
        >
          <div className="flex flex-row items-center gap-2">
            <div className="flex flex-col">
              <figcaption className="text-sm font-medium dark:text-white">{module.name}</figcaption>
            </div>
          </div>
          <blockquote className="mt-2 text-xs">{module.body}</blockquote>
        </figure>
      ))}
    </Marquee>
  );
}
